@if (usePlaceHolder == false) {
  <div class="app-body">
    <!-- Main content -->
    <main class="main full-width">
      <!-- /.conainer-fluid -->
      <div class="p-3">
        @for (entity of registeredEntities; track entity; let i = $index) {
          <a class="my-3 entity-nav" [ngClass]="'entity-link-' + i"
            queryParamsHandling="merge" [routerLink]="[ '/manage/' + entity ]">
            <h4>{{ entity }}</h4>
          </a>
        }
      </div>
    </main>
  </div>
}

<!-- documentPlaceHolder utilizzato per sostituire il contenuto -->
<ng-template #documentPlaceHolder></ng-template>